module.exports = __webpack_public_path__ + "img/8@2x.8077c3bc.png";